export default __webpack_public_path__ + "static/media/bl.03e210d9.svg";